import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics-test-list';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const SORT_TEST_CASES = `${NAMESPACE}/SORT_TEST_CASES`;
export const SET_TEST_CASE_QUERY = `${NAMESPACE}/SET_TEST_CASE_QUERY`;
export const CHANGE_PAGINATION = `${NAMESPACE}/CHANGE_PAGINATION`;
export const CLEANUP_TEST_LIST = `${NAMESPACE}/CLEANUP_TEST_LIST`;
export const GET_TEST_CASES = createApiNamespacedConstants('GET_TEST_CASES');
